import React from 'react';
import { cn } from '@/lib/utils';

export const GlassCard = React.forwardRef(function GlassCard({ className = '', children, hover = true, ...props }, ref) {
    return (
        <div
            ref={ref}
            className={cn(
                'relative rounded-la border border-white/8 bg-white/[0.02] backdrop-blur-md',
                hover && 'transition-[background-color,border-color] duration-300 hover:bg-white/[0.035] hover:border-white/16',
                className,
            )}
            {...props}
        >
            {children}
        </div>
    );
});

export default GlassCard;
